import { connect } from "react-redux";
import React, { useEffect } from "react";
import "./SpamChatButton.css"
import { isChatSpam, markChatAsSpam } from "src/app/chats-panel/~store/actions/actions";
import { ISpamChatButtonProps } from "./~types/SpamChatButtonProps";
import { selectedChatIdSelector, selectedChatSelector } from "src/app/chats-panel/~store/selectors";
import { IApplicationState } from "src/~store/models/ApplicationState";
import { useTranslation } from "react-i18next";

type ReduxType = ReturnType<typeof mapStateToProps> & ISpamChatButtonProps;

const SpamChatButton = (props: ReduxType) => {
    const { t } = useTranslation();

    const handlePressEnter = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter") {
            props.markChatAsSpam(props.selectedChatId);
        }
    };

    useEffect(() => {
        if(props.selectedChatId) {
            props.isChatSpam(props.selectedChatId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.selectedChatId]);

    return (
        <React.Fragment >
            <div className="spam-chat-button" 
                onClick={() => props.markChatAsSpam(props.selectedChatId)}
                title={t('chat.markAsSpam')}
                onKeyDown={handlePressEnter}
                tabIndex={0}
            >
                <img alt="" src={props.selectedChat?.isSpam !== false ? require("./../../images/spam_on.svg").default : require("./../../images/spam_off.svg").default} /> 
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state: IApplicationState, externalProps: any) => {
    return {
      selectedChatId: selectedChatIdSelector(state),
      selectedChat: selectedChatSelector(state),
    };
  };
  
const mapDispatchToProps = (dispatch: any): ISpamChatButtonProps => {
return {
        markChatAsSpam: (chatId: number) => dispatch(markChatAsSpam(chatId)),
        isChatSpam: (chatId: number) => dispatch(isChatSpam(chatId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SpamChatButton);